<template>

  <!--  <div class="list vld-parent">-->
  <div>
    <!-- Loading screen -->
    <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
    <message v-for="msg of messages" :severity="msg.severity" :key="msg.content">{{msg.content}}</message>

    <Panel>
      <template #header>
        {{ seasonHeader }}
        <br/> {{ matchDayHeader }}. Spieltag
        <!-- Is Maintenance Mode? -->
        <span v-if="isMaintenance()" class="p-tag p-tag-danger p-ml-1 p-mb-1">Maintenance active</span>

      </template>

      <template #icons>
        <i class="pi pi-arrow-circle-left" v-responsive.sm.xs @click="$emit('back-to-match-day-list')"
           style="fontSize: 2rem"/>
      </template>

      <div v-if="ready">

        <!-- ==================================== -->
        <!-- Inline Dialog for editing match tips -->
        <!-- ==================================== -->
        <Dialog v-if="currentMatch !== null" header="Begegnung" :visible.sync="showTip" :closable="false" :modal="true">

          <!-- Error Message -->
          <InlineMessage severity="error" :hidden="!errorMessageVisible">{{ errorMessage }}</InlineMessage>

          <div class="p-grid p-fluid">
            <div class="p-col">
                <span class="p-float-label">
                  {{ currentMatch.homeTeam }}
                </span>
            </div>

            <div class="p-col">
                <span class="p-float-label">
                  {{ currentMatch.guestTeam }}
                </span>
            </div>
          </div>

          <div class="p-grid p-fluid">
            <div class="p-col-4">
              <InputNumber id="currentHomeScore" v-model="currentHomeScore" :min="0" showButtons
                           buttonLayout="vertical" :step="1" :disabled="isPassedTimeLimit()"
                           :readonly="true"
                           decrementButtonClass="p-button-outlined" incrementButtonClass="p-button-outlined"
                           incrementButtonIcon="pi pi-plus" decrementButtonIcon="pi pi-minus"/>
            </div>
            <div class="p-col-2">
            </div>

            <div class="p-col-4">
              <InputNumber id="currentGuestScore" v-model="currentGuestScore" :min="0" showButtons
                           buttonLayout="vertical" :step="1" :disabled="isPassedTimeLimit()"
                           :readonly="true"
                           decrementButtonClass="p-button-outlined" incrementButtonClass="p-button-outlined"
                           incrementButtonIcon="pi pi-plus" decrementButtonIcon="pi pi-minus"/>
            </div>
          </div>

          <template #footer>
            <Button @click="saveTip"
                    type="submit"
                    value="submit"
                    :disabled="isPassedTimeLimit()"
                    class="p-button-sm p-button-success">Speichern
            </Button>
            <Button @click="closeTipDialog()" class="p-button-sm p-button-primary" autofocus>
              Schliessen
            </Button>
          </template>
        </Dialog>

        <span v-touch:swipe.left="swipeLeft" v-touch:swipe.right="swipeRight">

            <!-- DATATABLE MATCHES -->
          <DataTable :value="matches"
                     :scrollable="true" scrollHeight="flex"
                     :style="{height: '70vh'}"
                     :selection.sync="currentMatch" selectionMode="single"
                     rowGroupMode="subheader" groupRowsBy="matchDate"
                     class="p-datatable-sm p-datatable-striped"
                     :rowClass="rowClass"
                     @row-select="onSelectMatch"
                     sortMode="single" sortField="matchDate" :sortOrder="1">

            <Column field="matchDate" header="Anstoss"></Column>

            <!-- HOME TEAM NAME -->
            <Column field="homeTeam" header="Heim">
              <template #body="slotProps">
                <img width="18px" heigth="20px" :src="slotProps.data.homeTeamImage">
                <span v-responsive.md.lg.xl class="p-ml-1">{{ slotProps.data.homeTeam }}</span>
                <span v-responsive.sm.xs class="p-ml-1">{{ slotProps.data.homeTeamShort }}</span>
              </template>
            </Column>

            <!-- GUEST TEAM NAME -->
            <Column field="guestTeam" header="Gast">
              <template #body="slotProps">
                <img width="18px" heigth="20px" :src="slotProps.data.guestTeamImage">
                <span v-responsive.md.lg.xl class="p-ml-1">{{ slotProps.data.guestTeam }}</span>
                <span v-responsive.sm.xs class="p-ml-1">{{ slotProps.data.guestTeamShort }}</span>
              </template>
            </Column>

            <!-- SCORE TIP -->
            <Column header="Tip" header-style="width:2.5em;">
              <template #body="slotProps">
                  {{ getTip(slotProps.data) }}
              </template>
            </Column>

            <!-- SCORE -->
            <Column header="Erg" header-style="width:2.5em;">
              <template #body="slotProps">
              {{ getScore(slotProps.data) }}
              </template>
            </Column>

            <!-- TIP POINTS -->
            <Column v-if="atLeastOneFinished" body-class="text-right" header="Pkt" header-style="width:2.5em;">
              <template #body="slotProps">
                <span class="p-badge p-badge-info">{{ getTipPoints(slotProps.data) }}</span>
              </template>
            </Column>

            <template #groupheader="slotProps">
                <span class="p-pl-1 p-pt-1 p-pb-1 p-pr-5">
                  {{ formatKickOffDate(slotProps.data.matchDate) }}
                </span>
            </template>

            <!-- MATCHES TOTAL POINTS -->
            <template v-if="atLeastOneFinished" #footer>
              Gesamtpunkte:
                <span class="p-badge p-badge-info p-ml-2">{{ matchDayPoints }}</span>
            </template>

          </DataTable>
       </span>
      </div>

    </Panel>

    <back-to-top text="Nach oben"></back-to-top>
  </div>

</template>

<script>
import MatchDataService from "../services/match-data.service";
// import MatchTip from "./MatchTip"
// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
import moment from "moment";

export default {
  name: "user-match-list",
  components: {
    Loading
  },
  props: {
    matchDayNumber: {
      Type: Number
    }
  },
  data() {
    return {
      matches: [],
      messages: [],
      errorMessage: null,
      errorMessageVisible: false,
      currentMatch: null,
      currentIndex: -1,
      isModalVisible: false,
      showTip: false,
      currentMatchDayNumber: null,
      currentSeason: null,
      seasonHeader: "",
      matchDayHeader: "",
      matchTip: {
        match_id: null
      },
      currentHomeScore: "!",
      currentGuestScore: "!",
      matchDayPoints: 0,
      atLeastOneFinished: false,
      isLoading: false,
      fullPage: true,
      ready: false
    }
  },
  computed: {
    maintenanceUser: function () {
      return this.$store.state.sys.maintenanceUser;
    },
    currentUser() {
      return this.$store.state.auth.user;
    },
    isAdmin() {
      if (this.currentUser && this.currentUser.roles) {
        return this.currentUser.roles.includes('ROLE_ADMIN');
      }
      return false;
    }
  },
  methods: {
    addComponentMessage(severity, content){
      this.messages.push({severity: severity, content: content});
    },
    removeComponentMessage(){
      this.messages = [];
    },
    prepareRetrieveMatches() {
      this.isLoading = true;

      this.$store.dispatch('sys/getCurrentSeasonYear')
          .then(() => {
            this.currentSeasonYear = this.$store.state.sys.seasonYear;
            let isDayMissing = this.currentMatchDayNumber == null;

            if (isDayMissing == false) {
              return this.retrieveMatches();
            }
            this.$store.dispatch('sys/getCurrentMatchDay')
                .then(() => {
                  this.currentMatchDayNumber = this.$store.state.sys.matchDay;
                  this.retrieveMatches();
                })
          })

    },
    retrieveMatches() {
      console.log("Retrieving matches for season year " + this.currentSeasonYear + ' and day: ' + this.currentMatchDayNumber);
      MatchDataService.getAllMatchesWithUserTips({
        day: this.currentMatchDayNumber,
        maintenanceUser: this.$store.state.sys.maintenanceUser,
        seasonYear: this.currentSeasonYear
      })
          .then(response => {
            // console.log(JSON.stringify(response.data));
            this.matches = response.data;
            this.seasonHeader = this.matches[0].matchDay.season;
            this.matchDayHeader = this.matches[0].matchDay.matchDayNumber;
            // this.currentMatch = this.matches[0];
            this.ready = true;
            this.atLeastOneFinished = false;
            this.matchDayPoints = 0;
            this.calculateMatchDayPoints();
          })
          .finally(() => this.isLoading = false)
          .catch(err => {
            if (err.response.status === 401) {
              this.content = "Du bist nicht eingeloggt!";
              this.$store.dispatch('auth/logout');
              this.$router.push('/login');
            } else {
              this.content =
                  (err.response && err.response.data) ||
                  err.message ||
                  err.toString();
            }
            console.log(err);
            this.isLoading = false
          });
    },
    formatKickOffDate(timestamp) {
      return moment.utc(timestamp).local().locale('de').format("DD.MM.YYYY HH:mm") + " Uhr";
    },
    saveTip() {
      if (this.isPassedTimeLimit()) {
        this.errorMessage = "Spiel bereits begonnen!";
        this.showError = true;
      } else {
        if (this.homeScore === null) {
          this.errorMessage = "Heimtore fehlen!";
          this.showError = true;
        } else if (this.guestScore === null) {
          this.errorMessage = "Auswärtstore fehlen!";
          this.showError = true;
        } else {
          this.showError = false;
          this.message = "";
          var data;
          if (this.currentMatch.tips.length > 0) {
            data = {
              _id: this.currentMatch.tips[0]._id,
              match_id: this.currentMatch._id,
              homeScore: this.currentHomeScore,
              guestScore: this.currentGuestScore,
              maintenanceUser: this.maintenanceUser
            };
          } else {
            data = {
              match_id: this.currentMatch._id,
              homeScore: this.currentHomeScore,
              guestScore: this.currentGuestScore,
              maintenanceUser: this.maintenanceUser
            };
          }
          MatchDataService.saveTip(data)
              .then(response => {
                this.matchTip._id = response.data._id;
                this.showTip = false;
                this.currentMatch = null;
                this.refreshList();
              })
              .catch(e => {
                this.errorMessage = e.response.data.message;
                this.errorMessageVisible = true;
              });
        }
      }
    },
    calculateMatchDayPoints() {
      if (this.matches.length > 0) {
        this.matches.forEach(match => {
          if (match.isFinished) {
            this.atLeastOneFinished = true;
            if (this.getTipPoints(match) !== undefined && this.getTipPoints(match) !== "--") {
              this.matchDayPoints += this.getTipPoints(match);
            }
          }
        });
      }
    },
    refreshList() {
      this.ready = false;
      this.prepareRetrieveMatches();
    },
    onSelectMatch(data) {
      this.currentMatch = data.data;
      this.showModal();
    },
    closeTipDialog() {
      this.currentMatch = null;
      this.errorMessageVisible = false;
      this.errorMessage = null;
      this.showTip = false;
    },
    formatDate(date) {
      return MatchDataService.formatDate(date);
    },
    showModal() {
      // console.log("CurrentMatch: " + JSON.stringify(this.currentMatch));
      if (this.currentMatch.tips.length === 0) {
        this.currentHomeScore = 0;
        this.currentGuestScore = 0;
      } else {
        this.currentHomeScore = this.currentMatch.tips[0].homeScore;
        this.currentGuestScore = this.currentMatch.tips[0].guestScore;
      }
      this.showTip = true;
      // this.isModalVisible = true;
    },
    getTip(match) {
      if (match) {
        if (match.tips.length > 0) {
          return match.tips[0].homeScore + ":" + match.tips[0].guestScore;
        } else {
          return "! : !";
        }
      }
    },
    getTipPoints(match) {
      if (match && match.tips && match.tips.length > 0) {
        // console.log(match);
        if (match.tips[0].matchTipPoints || match.tips[0].matchTipPoints === 0) {
          return match.tips[0].matchTipPoints;
        } else {
          return "--";
        }
      }
    },
    getScore(currentMatch) {
      // console.log("CurrentMatch: " + JSON.stringify(currentMatch));
      if (currentMatch.isFinished) {
        return currentMatch.score.home + ":" + currentMatch.score.guest;
      } else {
        return "-:-";
      }
    },
    getHomeScore(currentMatch) {
      if (currentMatch) {
        if (currentMatch.tips.length > 0) {
          return currentMatch.tips[0].homeScore;
        } else {
          return "";
        }
      }
    },
    getGuestScore(currentMatch) {
      if (currentMatch) {
        if (currentMatch.tips.length > 0) {
          return currentMatch.tips[0].guestScore;
        } else {
          return "";
        }
      }
    },
    increaseMatchDay() {
      // console.log('Increasing match day from '  + this.currentMatchDayNumber);
      if (this.currentMatchDayNumber === 34) {
        return;
      }
      this.currentMatchDayNumber += 1;
      this.prepareRetrieveMatches();
    },
    decreaseMatchDay() {
      // console.log('Decreasing match day from '  + this.currentMatchDayNumber);
      if (this.currentMatchDayNumber === 1) {
        return;
      }
      this.currentMatchDayNumber -= 1;
      this.prepareRetrieveMatches();
    },
    swipeLeft() {
      this.increaseMatchDay();
    },
    swipeRight() {
      this.decreaseMatchDay();
    },
    isMaintenance() {
      // console.log("isMaintenance(): " + this.$store.state.sys.isMaintenance);
      return this.$store.state.sys.isMaintenance && this.isAdmin;
    },
    isPassedTimeLimit() {
      if (this.isMaintenance()) {
        return false;
      } else if (new Date(this.currentMatch.matchDate) < Date.now()) {
        return true;
      } else {
        // console.log(this.currentMatch.matchDate);
        return false;
      }
    },
    isHighlight(match) {
      return match.isHighlight === true;
    },
    rowClass(data) {
      return data.isHighlight === true ? 'highlight' : null;
    },
    doAjax() {
      this.isLoading = true;
      // simulate AJAX
      setTimeout(() => {
        this.isLoading = false
      }, 5000)
    }
  }
  ,
  watch: {
    matchDayNumber: function () {
      console.log("UserMatchList --> MatchDayNo: " + this.matchDayNumber + " --> Current: " + this.currentMatchDayNumber);
      this.currentMatchDayNumber = this.matchDayNumber;
      this.prepareRetrieveMatches();
    }
    ,
    maintenanceUser: function () {
      this.prepareRetrieveMatches();
    }
  }
  ,
  mounted() {
    console.log("UserMatchList --> mounted()");
    this.currentMatchDayNumber = this.matchDayNumber;
    this.prepareRetrieveMatches();
  }
}
</script>

<style>
.list {
  text-align: left;
  max-width: 750px;
  margin: auto;
}

.highlight {
  background-color: greenyellow !important;
}

.margin-small {
  margin: 0;
  line-height: 0.3em;
}

.badge-margin {
  margin-left: 2px;
}

.p-datatable .p-datatable-tbody > tr.p-highlight {
  background: transparent !important;
  color: #000000 !important;
}

.p-datatable .p-datatable-footer {
  text-align: right !important;
}

.p-datatable .p-rowgroup-header {
  background: #f8f9fa !important;
}

.p-panel .p-panel-content {
  padding: 0.2rem !important;
}

.p-col-12 {
  padding: 0.2rem !important;
}

span .p-ml-1 {
  font-size: 0.8em !important;
}

</style>